export default {"src":"/_next/static/media/chevron_blue_to_right.a7981caf.svg","height":14,"width":8};